import dayjs from 'shared/utils/dayjsConfig';

import { Periods } from 'shared/enums';

export const getThisWeekDates = () => [dayjs().day(0), dayjs().day(6)];

export const getLastWeekDates = () => [
  dayjs().subtract(1, 'week').day(0),
  dayjs().subtract(1, 'week').day(6)
];

export const getThisMonthDates = () => {
  const startDate = dayjs().date(1);
  const amountDaysInMonth = startDate.daysInMonth();
  return [startDate, dayjs().date(amountDaysInMonth)];
};

export const getLastMonthDates = () => {
  const lastMonth = dayjs().subtract(1, 'month');
  const startDate = lastMonth.date(1);
  const amountDaysInMonth = lastMonth.daysInMonth();
  return [startDate, dayjs().subtract(1, 'month').date(amountDaysInMonth)];
};

export const getThisYearDates = () => [
  dayjs().startOf('year'),
  dayjs().endOf('year')
];

export const getLastYearDates = () => [
  dayjs().subtract(1, 'year').startOf('year'),
  dayjs().subtract(1, 'year').endOf('year')
];

export const getTodayDates = () => [dayjs(), dayjs()];

export const getLast7DaysDates = () => [
  dayjs().subtract(7, 'day').startOf('day'),
  dayjs().endOf('day')
];

export const getLast30DaysDates = () => [
  dayjs().subtract(30, 'day').startOf('day'),
  dayjs().endOf('day')
];

export const getFirstQuarterDates = () => [
  dayjs().startOf('year'),
  dayjs().month(2).endOf('month')
];

export const getSecondQuarterDates = () => [
  dayjs().month(3).startOf('month'),
  dayjs().month(5).endOf('month')
];

export const getThirdQuarterDates = () => [
  dayjs().month(6).startOf('month'),
  dayjs().month(8).endOf('month')
];

export const getFourthQuarterDates = () => [
  dayjs().month(9).startOf('month'),
  dayjs().endOf('year')
];

export const convertMillisecondsToTime = (amount: number) => {
  let seconds = Math.floor(amount / 1000);
  let minutes = 0;
  let hours = 0;
  let days = 0;

  if (seconds > 59) {
    minutes = Math.floor(seconds / 60);
    seconds = seconds - minutes * 60;
  }

  if (minutes && minutes > 59) {
    hours = Math.floor(minutes / 60);
    minutes = minutes - hours * 60;
  }

  if (hours && hours > 23) {
    days = Math.floor(hours / 24);
    hours = hours - days * 24;
  }

  return `${days ? `${days}d ` : ''}${hours ? `${hours}h ` : ''}${
    minutes ? `${minutes}m` : ''
  }${!minutes && seconds ? '1m' : ''}`;
};

export const convertFloatMinutesToTime = (amount: string) => {
  const [m, s] = amount.split('.');
  const seconds = Math.floor((+s * 60) / 100);

  let hours;
  let minutes = +m;

  if (+minutes > 59) {
    hours = Math.floor(+minutes / 60);
    minutes = +minutes - hours * 60;
  }

  return `${hours ? `${hours}h ` : ''}${minutes ? `${minutes}m ` : '0m '}${
    seconds ? `${seconds}s` : ''
  }`;
};

export const convertDate = (
  date: Date | string,
  markAsUTC: boolean = true,
  format: string = 'YYYY-MM-DDTHH:mm:ss.SSS'
) => {
  // Add a Z to the date to indicate it is already UTC
  const isUTC = markAsUTC ? 'Z' : '';
  return dayjs(date).format(`${format}[${isUTC}]`);
};

export const getDurationData = (date: string, period: Periods) => {
  const dob = dayjs.utc(date);
  const today = dayjs.utc();

  const duration = dayjs.duration({
    [period]: today.diff(dob, period, false)
  });

  let periodDuration;

  switch (period) {
    case 'years':
      periodDuration = duration.years();
      break;
    case 'months':
      periodDuration = duration.months();
      break;
    case 'days':
      periodDuration = duration.days();
      break;
    case 'hours':
      periodDuration = duration.hours();
      break;

    default:
      break;
  }

  return { duration, periodDuration };
};

export const getAge = (dateOfBirth: string) => {
  let durationData;
  const periods = Object.values(Periods);

  for (let period = 0; period < periods.length; period++) {
    durationData = getDurationData(dateOfBirth, periods[period]);
    if (durationData.periodDuration) break;
    else continue;
  }

  if (durationData?.periodDuration && durationData.periodDuration < 0) {
    return 'Invalid date of birth';
  }

  const ageString = durationData?.duration.humanize();
  return `${ageString} old`;
};

export const sortByDate = (arrayToSort: any[], sortByParameter: string) => {
  return arrayToSort.sort((a, b) => {
    const dateA = new Date(a[sortByParameter]);
    const dateB = new Date(b[sortByParameter]);
    return dateB.getTime() - dateA.getTime();
  });
};
